import { SxProps } from "@mui/material";

export const containerStyle = {
  width: "100%",
  backgroundColor: "#fff",
  borderRadius: "10px",
  padding: "20px",
  marginTop: "10px",
  boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
};

export const searchAndSortContainer = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "20px",
  width: "100%",
  gap: "20px",
  flexWrap: "wrap",
  padding: "0 15px",
};

export const sortByContainer = {
  display: "flex",
  alignItems: "center",
  backgroundColor: "#F9FBFF",
  borderRadius: "10px",
  padding: "0 8px",
  height: "40px",
  boxShadow: 3,
};

export const sortByLabelStyle: SxProps = {
  marginRight: -1.1,
  color: "gray",
  fontSize: "12px",
  fontFamily: "Poppins, sans-serif",
  marginLeft: 0.5,
};

export const sortBySelectStyle = {
  width: "110px",
  height: "100%",
  fontWeight: 600,
  backgroundColor: "transparent",
  fontSize: "13px",
  fontFamily: "Poppins, sans-serif",
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
};

export const mainContentStyle = {
  width: "100%",
  overflowX: "auto",
};

export const paginationContainerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "20px",
  flexWrap: "wrap",
  gap: "10px",
};

export const paginationCaptionStyle = {
  fontSize: "14px",
  color: "#555",
};

export const downloadButtonStyles = {
  cursor: "pointer",
  height: "36px",
  marginLeft: "10px",
};
